var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-message"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.addGame($event)}}},[_c('button',{staticClass:"btn light-blue lighten-2"},[_vm._v("משחק-חדש")])]),_vm._v(" "),(_vm.newGame)?_c('p',[_vm._v(_vm._s(_vm.newGame))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47b77b2b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewGame.vue
// module id = null
// module chunks = 